/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'host-hdr';
const prefix = `${moduleName}.${componentName}`;

export const hostHeaderLabel = `${prefix}.hostHeaderLabel`;
export const criteriaLabel = `${prefix}.criteriaLabel`;
export const enterCriteriaLabel = `${prefix}.enterCriteriaLabel`;
export const valueLabel = `${prefix}.valueLabel`;
export const enterValuesLabel = `${prefix}.enterValuesLabel`;
export const addValueLabel = `${prefix}.addValueLabel`;

export const ENGLISH = {
    [hostHeaderLabel]: 'Host Header',
    [criteriaLabel]: 'Criteria',
    [enterCriteriaLabel]: 'Enter Criteria',
    [valueLabel]: 'Value',
    [addValueLabel]: 'Add Value',
    [enterValuesLabel]: 'Enter Values',
};
